/*
 *  -----------------------------------------------------------------------
 *    <copyright file="generate-report-dialog.data.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2024 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

export const IReportInitialState = {
    onlyIncludeReviewed: false,
    datasetId: '',
    comparisonDatasetId: '',
    reportName: '',
    reportVersion: '',
    riskReviewId: '00000000-0000-0000-0000-000000000000',
};
